import _slicedToArray from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["innerProps"],
    _excluded2 = ["children"],
    _excluded3 = ["menuWidth", "menuZIndex", "withPortal", "optionWithTooltip", "showTooltip", "customStyles"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Tooltip, forwardRef, useToken } from '@chakra-ui/react';
import { Select as ChakraReactSelect, chakraComponents } from 'chakra-react-select';
import { jsx as _jsx } from "react/jsx-runtime";

// Custom component should be declared outside of the Select scope
// https://react-select.com/components#defining-components
// https://github.com/JedWatson/react-select/issues/4170#issuecomment-759952288
var SelectContainer = function SelectContainer(_ref) {
  var innerProps = _ref.innerProps,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(chakraComponents.SelectContainer, _objectSpread(_objectSpread({}, props), {}, {
    innerProps: _objectSpread(_objectSpread({}, innerProps), {}, {
      'data-test': props.selectProps['data-test']
    })
  }));
};

var Control = function Control(_ref2) {
  var children = _ref2.children,
      rest = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/_jsx("div", {
    onClick: function onClick(e) {
      return e.stopPropagation();
    },
    e2eid: "Form_Select_div",
    children: /*#__PURE__*/_jsx(chakraComponents.Control, _objectSpread(_objectSpread({}, rest), {}, {
      children: children
    }))
  });
}; // https://stackoverflow.com/questions/61576344/how-to-show-tooltip-for-each-react-select-multivalue-element


var MultiValueContainer = function MultiValueContainer(props) {
  return /*#__PURE__*/_jsx(Tooltip, {
    label: props.data.label,
    placement: "right",
    e2eid: "Form_Select_Tooltip",
    children: /*#__PURE__*/_jsx("span", {
      style: {
        overflow: 'hidden'
      },
      e2eid: "Form_Select_span",
      children: /*#__PURE__*/_jsx(chakraComponents.MultiValueContainer, _objectSpread({}, props))
    })
  });
};

export var TooltipSelectOption = function TooltipSelectOption(props) {
  var innerRef = props.innerRef,
      innerProps = props.innerProps,
      label = props.label;
  return /*#__PURE__*/_jsx(Tooltip, {
    label: label,
    e2eid: "Form_Select_Tooltip",
    children: /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({
      w: "full",
      ref: innerRef
    }, innerProps), {}, {
      e2eid: "Form_Select_Box",
      children: /*#__PURE__*/_jsx(chakraComponents.Option, _objectSpread({}, props))
    }))
  });
};
export var chakraReactSelectStyles = {
  control: function control(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      background: 'white'
    });
  },
  valueContainer: function valueContainer(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      p: [0, 1]
    });
  },
  placeholder: function placeholder(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      color: 'gray.400'
    });
  },
  singleValue: function singleValue(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      textOverflow: 'clip',
      fontWeight: 400
    });
  },
  option: function option(provided) {
    return _objectSpread(_objectSpread({}, provided), {}, {
      display: 'block',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontWeight: 400
    });
  }
};

var SelectInner = function SelectInner(_ref3, ref) {
  var _ref3$menuWidth = _ref3.menuWidth,
      menuWidth = _ref3$menuWidth === void 0 ? 'full' : _ref3$menuWidth,
      _ref3$menuZIndex = _ref3.menuZIndex,
      menuZIndex = _ref3$menuZIndex === void 0 ? 'modal' : _ref3$menuZIndex,
      _ref3$withPortal = _ref3.withPortal,
      withPortal = _ref3$withPortal === void 0 ? true : _ref3$withPortal,
      _ref3$optionWithToolt = _ref3.optionWithTooltip,
      optionWithTooltip = _ref3$optionWithToolt === void 0 ? false : _ref3$optionWithToolt,
      _ref3$showTooltip = _ref3.showTooltip,
      showTooltip = _ref3$showTooltip === void 0 ? false : _ref3$showTooltip,
      _ref3$customStyles = _ref3.customStyles,
      customStyles = _ref3$customStyles === void 0 ? {} : _ref3$customStyles,
      props = _objectWithoutProperties(_ref3, _excluded3);

  var _useToken = useToken('zIndices', [menuZIndex]),
      _useToken2 = _slicedToArray(_useToken, 1),
      zIndexDropdown = _useToken2[0];

  return /*#__PURE__*/_jsx(ChakraReactSelect, _objectSpread(_objectSpread(_objectSpread({}, props), {}, {
    useBasicStyles: true,
    chakraStyles: _objectSpread(_objectSpread(_objectSpread({}, chakraReactSelectStyles), customStyles), {}, {
      menu: function menu(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          width: menuWidth
        });
      }
    })
  }, withPortal && {
    // the way to style menuPortal: https://github.com/csandman/chakra-react-select/tree/v3.0.5#caveats
    styles: {
      menuPortal: function menuPortal(provided) {
        return _objectSpread(_objectSpread({}, provided), {}, {
          zIndex: zIndexDropdown
        });
      }
    },
    menuPortalTarget: props.menuPortalTarget || document.body,
    menuPosition: 'fixed'
  }), {}, {
    menuShouldScrollIntoView: false // add data-* attribute on Select component: https://github.com/csandman/chakra-react-select/issues/306
    ,
    components: {
      SelectContainer: SelectContainer,
      Control: Control,
      MultiValueContainer: showTooltip ? MultiValueContainer : chakraComponents.MultiValueContainer,
      Option: optionWithTooltip ? TooltipSelectOption : chakraComponents.Option
    },
    ref: ref,
    e2eid: "Form_Select_ChakraReactSelect"
  }));
};

export var Select = forwardRef(SelectInner);